import React, { useState, useRef, useEffect } from 'react';

import Checkbox from '../../../../checkbox/Checkbox.jsx';

import SvgDefaultArrowUp from '../../../../svg/icons/default-arrow-up.svg';
import SvgDefaultArrowDown from '../../../../svg/icons/default-arrow-down.svg';

function FilterCheckboxGroup({ items, id, onChange, selected, showMoreLabel, showLessLabel }) {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (expanded && ref.current) ref.current.focus();
  }, [expanded]);

  return (
    <div aria-expanded={expanded} className="filter-checkbox-group">
      {items.map((item, index) => (
        <div
          key={item.handle}
          aria-hidden={index > 3 && !expanded}
          style={{ display: index > 3 && !expanded ? 'none' : 'block' }}
          className="filter-checkbox-group__item"
        >
          <Checkbox
            ref={index === 4 ? ref : undefined}
            key={item.handle}
            id={id}
            label={item.label}
            checked={(selected || []).includes(item.handle)}
            onChange={() => onChange(item.handle)}
            name={item.handle}
          />
        </div>
      ))}

      {items.length > 4 ? (
        <button
          className="link"
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          aria-label={expanded ? showLessLabel : showMoreLabel}
          title={expanded ? showLessLabel : showMoreLabel}
        >
          <span className="text text--link">{expanded ? showLessLabel : showMoreLabel}</span>

          {expanded ? <SvgDefaultArrowUp /> : <SvgDefaultArrowDown />}
        </button>
      ) : null}
    </div>
  );
}

export default FilterCheckboxGroup;
